export const getAuthToken = (): string => {
  return localStorage.getItem("auth_token") || "";
};

export const setAuthToken = (value: string): void => {
  return localStorage.setItem("auth_token", value);
};

export const isUserLoggedIn = (): boolean => {
  return !!getAuthToken();
};

export const getUserInfo = (): string => {
  return localStorage.getItem("user_info") || "";
};

export const setUserInfo = (value: string): void => {
  return localStorage.setItem("user_info", value);
};
